import React, { useState, useEffect, createContext, useMemo } from 'react';

export const SaveBarContainerContext = createContext<{
  containerElement: HTMLDivElement | null;
}>({
  containerElement: null,
});

export interface SaveBarProviderProps {
  children: React.ReactNode;
  /** The ref to the container for the save bar */
  portalContainerRef: React.RefObject<HTMLDivElement>;
}

/**
 * The component to use along the `<SaveBar>`;
 * Once `<SaveBar>` is wrapper with `<SaveBarProvider>`,
 * it will appear inside the div to which `portalContainerRef` points.
 */
export function SaveBarProvider({ portalContainerRef, children }: SaveBarProviderProps) {
  const [containerElement, setContainerElement] = useState<HTMLDivElement | null>(null);
  const memoizedContainerElement = useMemo(() => ({ containerElement }), [containerElement]);

  // put the container for the save bar into the context when mounted
  useEffect(() => {
    setContainerElement(portalContainerRef.current);
  }, [portalContainerRef]);

  return (
    <SaveBarContainerContext.Provider value={memoizedContainerElement}>
      {children}
    </SaveBarContainerContext.Provider>
  );
}
